<!--
  --
  -- メールアドレス設定 ページ
  --
  -->
<template>
  <c-container form>
    <c-email-group
      :email="email"
      @verified="onVerified"
    >
      <!-- タイトル -->
      <template #title>メールアドレスを設定</template>

      <!-- Email の説明文 -->
      <template #email-note>
        <p class="text--primary">
          メールアドレスを入力して、確認コードを送信して下さい。<br>
          このメールアドレスはログインに必要です。
        </p>
        <p class="text--secondary">
          確認コードを記したメールが届かない場合、迷惑メールフィルタでブロックされている可能性があります。<br>
          迷惑メールフィルタの設定をご確認ください。<br>
          また、旧キャリアメール等で受信できない場合があります。<br>
          その場合は、Gmail等他のメールアドレスをご利用ください。<br>
          ※「docomo」「ezweb」「vodafone」
        </p>
      </template>

      <!-- Verify の説明文 -->
      <template #verify-note>
        <p class="text--primary">
          確認メールを送信しました。<br>
          メールに記載されている【確認コード】を入力して下さい。
        </p>
        <p class="text--secondary">
          メールが送信されるまでに最大5分程度かかる場合があります。<br>
          しばらく経っても確認メールが届かない場合は、メールアドレスを確認の上、再度メールを送信して下さい。
        </p>
      </template>
    </c-email-group>

    <!-- タイムアウト制御 -->
    <c-timeout/>
  </c-container>
</template>

<script>
import page from '@/mixins/page'
import CEmailGroup from './CEmailGroup'
import CTimeout from '../CTimeout'

import { run } from '@/libs/a'

export default {
  name: 'Email',
  mixins: [
    page('メールアドレスを設定')
  ],
  components: {
    CEmailGroup,
    CTimeout
  },
  computed: {
    // 既に入力されたメールアドレス
    email () {
      return this.getters['register/account'].email
    },

    // メール送信ドメイン
    hostname () {
      return this.getters['org/emailDomain']
    }
  },
  methods: {
    /**
     * メールアドレスが認証された
     *
     * @param {String} email 認証されたメールアドレス
     * @param {Function} failed エラー時に呼び出すコールバック関数
     */
    onVerified (email, failed) {
      run(async () => {
        // store にメールアドレスを保存する
        this.commit('register/setEmail', email)

        // 次のページへ
        await this.goTo({ name: 'register/password' })
      })
    }
  }
}
</script>
